import React from "react";
import { Box, Typography } from "@mui/material";

const MonthlyBilling = () => (
  <Box sx={{ p: 2, minHeight: 200, backgroundColor: "#f8fafc", borderRadius: 2 }}>
    <Typography sx={{ fontFamily: "Rubik", color: "#64748b", fontSize: 14 }}>
      Fatturato mensile: non in scope (sospeso).
    </Typography>
  </Box>
);

export default MonthlyBilling;
